import { render, staticRenderFns } from "./instantwin_message_dialog.vue?vue&type=template&id=eb5be6f0&scoped=true"
import script from "./instantwin_message_dialog.vue?vue&type=script&lang=ts"
export * from "./instantwin_message_dialog.vue?vue&type=script&lang=ts"
import style0 from "./instantwin_message_dialog.vue?vue&type=style&index=0&id=eb5be6f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5be6f0",
  null
  
)

export default component.exports